import { mapGetters } from "vuex";
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators";
import { lesseeTargetValidations } from "@/components/RentAdjustment/Utils";

const mixin = {
    data() {
        return {
            tagMonthly: 5,
        }
    },
    validations: {
        getFormData: {
            companyIdOriginal: { required },
            companyIdTarget: {
                required: requiredIf(function () {
                    return !this.getFormData.isNewCompany;
                }),
            },
            isNewCompany: { required },
            targetCompany: {
                new: {
                    newCompanyData: {
                        companyName: {
                            required: requiredIf(function () {
                                return this.getFormData.isNewCompany;
                            }),
                        },
                    },
                },
                existing: {
                    newCompanyData: {
                        companyName: {
                            required: requiredIf(function () {
                                return !this.getFormData.isNewCompany;
                            }),
                        },
                    },
                },
            },
            depositTransfer: { required },
            reasonNoDepositTransfer: {
                required: requiredIf(function () {
                    return !this.getFormData.depositTransfer;
                }),
            },
            effectiveMonth: {
                requiredIf: requiredIf(function () {
                    return !this.getFormData.clientRequestMidMonth;
                }),
            },
            midMonthEffectiveDate: {
                requiredIf: requiredIf(function () {
                    return this.getFormData.clientRequestMidMonth;
                }),
            },
        },
        targetCompany: {
            new: lesseeTargetValidations,
            existing: lesseeTargetValidations,
        },
    },
    computed: {
        ...mapGetters("rentAdjustment", {
            disabledNotDraft: "getDisabledNotDraft",
            getFormData: "getFormData",
            targetCompany: "getTargetCompany",
            rentAdjustmentStatus: "getStatus",
        }),
        disabledInput() {
            let permissions = localStorage.getItem("roles");
            if (!permissions) return true;
            permissions = JSON.parse(permissions);
            const params = this.$route.params;
            if (params && params.id) {
                if (params.id !== "create" && !permissions.includes("28.3")) {
                    return true
                }
                if (params.id === "create" && !permissions.includes("28.2")) {
                    return true
                }
            }
            return this.disabledNotDraft;
        },
        chooseUnitCompleted() {
            const validate = this.$v.getFormData;
            let anySelectedUnit = false;
            this.getFormData.units.forEach((unit) => {
                if (unit.selected && unit.targetUnit.orderCode) {
                    anySelectedUnit = true;
                }
                unit.children.forEach((child) => {
                    if (child.selected && child.targetUnit.orderCode) {
                        anySelectedUnit = true;
                    }
                });
            });
            return (
                !validate.depositTransfer.$invalid &&
                !validate.reasonNoDepositTransfer.$invalid &&
                anySelectedUnit
            );
        },
        companyInfoCompleted() {
            if (!this.companyTargetDataCompleted) return false;
            const validate = this.$v.getFormData;
            return (
                !validate.companyIdOriginal.$invalid &&
                !validate.companyIdTarget.$invalid &&
                !validate.targetCompany.$invalid
            );
        },
        companyTargetDataCompleted() {
            const validate = this.$v.targetCompany;
            if (this.getFormData.isNewCompany && validate.new.$invalid) return false;
            if (!this.getFormData.isNewCompany && validate.existing.$invalid) return false;
            return true
        },
        effectiveDateCompleted() {
            const validate = this.$v.getFormData;
            if (this.getFormData.clientRequestMidMonth) {
                return (
                    !validate.midMonthEffectiveDate.$invalid &&
                    this.getFormData.termChecked
                );
            }
            return !validate.effectiveMonth.$invalid;
        },
    },
    methods: {
        displayedTag(tag) {
            let result = `${tag.billingCalculation} · ${tag.billingStart} · `;
            if (tag.customRecurringBillingDay) {
                result += `tgl ${tag.customRecurringBillingDay}`;
            } else if (tag.recurringBillingDay === "Every 1st of the month") {
                result += "tgl 1";
            } else {
                result += "Start Rent";
            }
            return result;
        }
    }

}

export default mixin


// WEBPACK FOOTER //
// ./src/components/RentAdjustment/mixin.js